import { getPercent } from "@helpers";
import { InvestmentChartData } from "@helpers/charts/mergeCloseByDate";
import { prepareChartData } from "@components/Chart/highcharts/DrawLineChart";

export const calculatePercents = (
  quotes: InvestmentChartData[]
): InvestmentChartData[] => {
  let reference = quotes[0];
  let value = 1;
  let comparedValue = 1;
  let recommender1 = 1;
  let recommender2 = 1;
  let recommender3 = 1;

  return quotes.map((current) => {
    value *= current.value / reference.value;
    if (current.comparedValue && reference.comparedValue) {
      comparedValue *= current.comparedValue / reference.comparedValue;
    }

    if (current.recommender1 && reference.recommender1) {
      recommender1 *= current.recommender1 / reference.recommender1;
    }
    if (current.recommender2 && reference.recommender2) {
      recommender2 *= current.recommender2 / reference.recommender2;
    }
    if (current.recommender3 && reference.recommender3) {
      recommender3 *= current.recommender3 / reference.recommender3;
    }

    reference = current;

    const percents = getPercent(value);
    const secondaryPercents = getPercent(comparedValue);
    const recommender1Percents = getPercent(recommender1);
    const recommender2Percents = getPercent(recommender2);
    const recommender3Percents = getPercent(recommender3);

    return {
      ...current,
      value: percents,
      originalValue: current.value,
      eventsValue: percents,
      comparedValue: secondaryPercents,
      comparedOriginalValue: current.comparedValue,
      recommender1: recommender1Percents,
      recommender2: recommender2Percents,
      recommender3: recommender3Percents,
    };
  });
};

export const prepareInvestmentsData = (
  chartData: InvestmentChartData[],
  chartColors: Record<string, string>,
  comparisonMode: boolean,
  comparedTicker?: string | null,
  hasRecommenderData?: {
    hasR1Data: boolean;
    hasR2Data: boolean;
    hasR3Data: boolean;
  },
  isFetching?: boolean
) => {
  if (chartData.length === 0) return [];

  const data = comparisonMode ? calculatePercents(chartData) : chartData;

  const dataKeys = {
    all: "value",
    comparison: "comparedValue",
    recommender1: "recommender1",
    recommender2: "recommender2",
    recommender3: "recommender3",
  } as const;

  const series = ["all"];

  if (comparedTicker && !isFetching) {
    series.push("comparison");
  }
  if (hasRecommenderData?.hasR1Data) {
    series.push("recommender1");
  }
  if (hasRecommenderData?.hasR2Data) {
    series.push("recommender2");
  }
  if (hasRecommenderData?.hasR3Data) {
    series.push("recommender3");
  }

  return prepareChartData(data, series, dataKeys, chartColors);
};
